import { Button } from "react-admin";
import { type EditCalendarEventDto, serverAPI } from "../../api/server.api";
import { VehicleEvent, VehicleEventTypeEnum } from "../../model/autovioCalendarEvents";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { assertValid } from "../../backoffice.utils";
import { VehicleEventForm, VehicleEventFormValues } from "../../misc/calendar/VehicleEventForm";

export function EditVehicleEventForm(props: { event: VehicleEvent; closeEditMode: () => void }) {
  const { event, closeEditMode } = props;

  const onSubmit = async (formValues: VehicleEventFormValues) =>
    runSafely(
      async () => {
        const { start, end, vehicleEventType, noteForInstructor } = formValues;
        const vehicleEventType_ = VehicleEventTypeEnum.parse(vehicleEventType);
        const start_ = assertValid(start, "start");
        const dto: EditCalendarEventDto = {
          type: "VehicleEvent" as const,
          start: start_.toISO(),
          end: assertValid(end, "end")
            .set({
              year: start_.year,
              month: start_.month,
              day: start_.day,
            })
            .toISO(),
          vehicleEventType: vehicleEventType_,
          noteForInstructor: noteForInstructor ?? undefined,
        };
        await serverAPI.editCalendarEvent({ eventId: event.id, dto });
      },
      {
        onSuccess: closeEditMode,
      },
    );

  return (
    <VehicleEventForm
      vehicleEvent={event}
      vehicleId={event.vehicleId}
      onSubmit={onSubmit}
      backButton={
        <Button
          startIcon={<NavigateBeforeIcon />}
          label="Zurück"
          variant="outlined"
          size="medium"
          onClick={closeEditMode}
        />
      }
    />
  );
}
